import { render, staticRenderFns } from "./JSpace.vue?vue&type=template&id=c3b3f978&scoped=true&"
import script from "./JSpace.vue?vue&type=script&setup=true&lang=js&"
export * from "./JSpace.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b3f978",
  null
  
)

export default component.exports